import { useState } from "react";
import { Accordion, Alert, AlertProps } from "react-bootstrap";

import { IconFromVariant, SvgSprite } from ".";

interface AlertAccordionProps extends AlertProps {
  id: string;
  header: React.ReactNode;
  body: React.ReactNode;
}

export const AlertAccordion = ({
  id,
  variant = "warning",
  header,
  body,
}: AlertAccordionProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Alert show variant={variant}>
      <Accordion onSelect={() => setIsOpen((prev) => !prev)}>
        <h2 className="h6 mb-0">
          <Accordion.Toggle
            aria-expanded={isOpen}
            aria-controls={`${id}-body`}
            id={`${id}-label`}
            css={`
              color: currentColor;
            `}
            className="bg-transparent border-0 p-0 d-flex align-items-center w-100"
            eventKey="0"
          >
            <IconFromVariant variant={variant} className="mr-3" />
            <b>{header}</b>
            <SvgSprite
              id="icons:chev-right"
              width={20}
              height={20}
              className="ml-auto"
              style={{
                transition: "200ms transform ease-in-out",
                transform: isOpen ? "rotate(90deg)" : "rotate(0deg)",
                transformOrigin: "75% 50%",
              }}
            />
          </Accordion.Toggle>
        </h2>
        <Accordion.Collapse
          role="region"
          aria-labelledby={`${id}-label`}
          id={`${id}-body`}
          eventKey="0"
          hidden={!isOpen}
        >
          <div className="card-body ml-4 px-3 pb-0">{body}</div>
        </Accordion.Collapse>
      </Accordion>
    </Alert>
  );
};
